import type { ItemListFiltersState, ItemListFiltersStateWithRefs } from './useFilter'
import { SEARCH_LIST_DEFAULT_SORTING_TYPE } from '@autobid/ui/constants/carsList/SEARCH_LIST_DEFAULT_SORTING_TYPE'

export function useFilterState(): ItemListFiltersStateWithRefs {
  const currentPage = useState<ItemListFiltersState['currentPage']>('cars-list-state-currentPage', () => 1)
  const sortingType = useState<ItemListFiltersState['sortingType']>(
    'cars-list-state-sortingType',
    () => SEARCH_LIST_DEFAULT_SORTING_TYPE,
  )
  const pageType = useState<ItemListFiltersState['pageType']>('cars-list-state-pageType', () => undefined)
  const e174 = useState<ItemListFiltersState['e174']>('cars-list-state-e174', () => undefined)
  const category = useState<ItemListFiltersState['category']>('cars-list-state-category', () => [])
  const manufacturerModel = useState<ItemListFiltersState['manufacturerModel']>(
    'cars-list-state-manufacturerModel',
    () => [],
  )
  const e17 = useState<ItemListFiltersState['e17']>('cars-list-state-e17', () => [])
  const e223 = useState<ItemListFiltersState['e223']>('cars-list-state-e223', () => [])
  const e19from = useState<ItemListFiltersState['e19from']>('cars-list-state-e19from', () => undefined)
  const e19to = useState<ItemListFiltersState['e19to']>('cars-list-state-e19to', () => undefined)
  const e68from = useState<ItemListFiltersState['e68from']>('cars-list-state-e68from', () => undefined)
  const e68to = useState<ItemListFiltersState['e68to']>('cars-list-state-e68to', () => undefined)
  const e21from = useState<ItemListFiltersState['e21from']>('cars-list-state-e21from', () => undefined)
  const e21to = useState<ItemListFiltersState['e21to']>('cars-list-state-e21to', () => undefined)
  const e31 = useState<ItemListFiltersState['e31']>('cars-list-state-e31', () => [])
  const e70 = useState<ItemListFiltersState['e70']>('cars-list-state-e70', () => undefined)
  const e24 = useState<ItemListFiltersState['e24']>('cars-list-state-e24', () => undefined)
  const earliestDateOfAddition = useState<ItemListFiltersState['earliestDateOfAddition']>(
    'cars-list-state-earliestDateOfAddition',
    () => undefined,
  )
  const stage = useState<ItemListFiltersState['stage']>('cars-list-state-stage', () => undefined)
  const supplierIds = useState<ItemListFiltersState['supplierIds']>('cars-list-state-supplierIds', () => [])

  return {
    currentPage,
    sortingType,
    pageType,
    e174,
    category,
    manufacturerModel,
    e17,
    e223,
    e19from,
    e19to,
    e68from,
    e68to,
    e21from,
    e21to,
    e31,
    e70,
    e24,
    earliestDateOfAddition,
    stage,
    supplierIds,
  }
}
